import styled from '@emotion/styled';
import { Text } from '~/shared/components/Text';
import { breakpoints } from '~/theme';

export const BackButton = styled.button(({ theme }) => ({
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
    padding: 0,
    display: 'flex',

    svg: {
        width: theme.space[4],
        height: theme.space[4],
        color: theme.colors.black,
    },

    ':hover, :focus, :active': {
        backgroundColor: 'transparent',
    },
}));

export const Section = styled.div(({ theme }) => ({
    display: 'grid',
    gap: theme.space[3],
}));

export const Header = styled.div(() => ({
    display: 'flex',
    justifyContent: 'space-between',
}));

export const StyledHeaderText = styled(Text)(() => ({
    gridColumn: '1 / span 7',
    display: 'grid',
    [breakpoints.sm]: {
        gridColumn: '1 / span 4',
    },
}));

export const CardContainer = styled.div(() => ({}));

export const Card = styled.li(({ theme }) => ({
    background: theme.colors.offWhite,
    display: 'grid',
    gridTemplateColumns: '100px repeat(7, 1fr)',
    gap: theme.space[4],
    padding: theme.space[3],
    marginBottom: 2,
}));

export const Thumbnail = styled.figure(({ theme }) => ({
    background: theme.colors.white,
    margin: 0,
    width: '96px',
    height: '96px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

export const Info = styled.div(({ theme }) => ({
    gridColumn: '2 / span 3',
    alignItems: 'center',
    display: 'grid',
    gridTemplateRows: `auto ${theme.space[4]} ${theme.space[4]} ${theme.space[4]}`,
    gap: theme.space[1],
}));

export const Quantity = styled.div(({ theme }) => ({
    gridColumn: '5 / span 2',
    alignItems: 'center',
    display: 'grid',
    gridTemplateRows: `${theme.space[3]} ${theme.space[4]} ${theme.space[4]} ${theme.space[4]}`,
    gap: theme.space[1],
}));

export const Price = styled.div(({ theme }) => ({
    gridColumn: '7 / span 2',
    alignItems: 'center',
    display: 'grid',
    gridTemplateRows: `${theme.space[3]} ${theme.space[4]} ${theme.space[4]} ${theme.space[4]}`,
    gap: theme.space[1],
}));

export const EmptyList = styled.span(({ theme }) => ({
    background: theme.colors.offWhite,
    gap: theme.space[4],
    padding: theme.space[3],
    marginBottom: 2,

    [breakpoints.md]: {
        padding: theme.space[3],
        marginBottom: 2,
    },
}));

export const BottomCardDetails = styled.div(() => ({
    display: 'grid',
}));

export const QuantityWrapper = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'end',
    gap: theme.space[2],

    [breakpoints.md]: {
        gap: theme.space[4],
    },
}));

export const StyledPrice = styled.div(() => ({
    display: 'flex',
    justifyContent: 'end',
}));

export const StyledText = styled(Text)(({ theme }) => ({
    color: theme.colors.grey70,
    fontWeight: theme.fontWeights.normal,
}));
